import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Form, { Assinatura, Botao as BotaoForm } from 'Component/Form';
import Imagem from 'Component/Imagem';
import Holerite from 'Interface/Holerites';
import {
  useEditarHoleriteMutation,
  useRecuperarHoleriteQuery,
} from 'View/Service/Default/Holerites';

const regras = object({
  assinatura: string().required('Obrigatório'),
});

const Assinar = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const toast = useToast();
  const navegacao = useNavigate();

  const [editarHolerite] = useEditarHoleriteMutation();

  const { data: { holerite } = {} } = useRecuperarHoleriteQuery(id);

  const enviar = async (dados: Holerite): Promise<void> => {
    try {
      await editarHolerite({
        ...dados,
        assinatura: dados.assinatura,
        assinado: 1,
        data_da_assinatura: DateTime.now().toISO(),
      }).unwrap();

      navegacao('/holerites/historico');
    } catch (erro) {
      toast({
        tema: 'danger',
        titulo: 'Erro ao assinar',
        conteudo: 'Verifique os logs para mais informações',
      });
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center py-5">
        <div className="col-md-5">
          <h1 className="text-center">Assinar holerite</h1>
          <p className="text-center">
            Faça sua assinatura no campo abaixo para assinar seu holerite.
          </p>
          <Form
            onSubmit={enviar}
            regras={regras}
            inicial={holerite}
            desabilitado={holerite?.assinado == 1}
          >
            {holerite?.assinado ? (
              <Imagem src={holerite.assinatura} className="img-fluid" />
            ) : (
              <Assinatura name="assinatura" rotulo="Assinatura" />
            )}
            <div className="text-center">
              <BotaoForm>Assinar</BotaoForm>{' '}
            </div>
          </Form>
          <div className="text-center mt-3">
            <BotaoLink to="/holerites/historico" tema="light">
              Cancelar
            </BotaoLink>{' '}
            <Botao
              icone="cloud-download-fill"
              tema="success"
              onClick={() => window.open(`/holerites/imprimir/${id}`)}
            >
              Download
            </Botao>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assinar;
